// extracted by mini-css-extract-plugin
module.exports = {"pageNum":"Pagination_pageNum__3rwi4","selected":"Pagination_selected__2KGQK","arrow":"Pagination_arrow__Fh4V7"};